import { render, staticRenderFns } from "./rf_Icon.vue?vue&type=template&id=67e31e88&scoped=true&"
import script from "./rf_Icon.vue?vue&type=script&lang=js&"
export * from "./rf_Icon.vue?vue&type=script&lang=js&"
import style0 from "./rf_Icon.vue?vue&type=style&index=0&id=67e31e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e31e88",
  null
  
)

export default component.exports